import { updateDraft } from '@/sdk/clients/ServicesRequest'
import logger from '@/sdk/logger'

export default {
  async submitDataFromServicePage({ rootState }, value) {
    const draftUuid = rootState.registration.serviceRequestDraftId

    try {
      return await updateDraft(value, draftUuid)
    } catch (error) {
      const { postcode } = rootState

      logger.error('failed trying to save the services page', {
        error,
        tags: ['bookingFunnelSteps', 'http', 'services', 'step1'],
        // TODO: Remove additionalData after "/api/booking/service-request-draft/null" error is fixed
        additionalData: {
          postcode,
        },
      })

      throw error
    }
  },

  async updateCarePlan({ rootState }, carePlanId) {
    const SRDraftId = rootState.registration.serviceRequestDraftId

    const payload = {
      update: {
        type: 'care_plan',
        data: {
          id: carePlanId,
        },
      },
    }

    try {
      return await updateDraft(payload, SRDraftId)
    } catch (error) {
      logger.error('failed trying to save the selected care plan', {
        error,
        tags: ['carePlans', 'bookingFunnelSteps', 'http', 'services', 'step1'],
      })

      throw error
    }
  },

  setServicePageData({ commit }, servicePageData) {
    commit('setServicePageData', servicePageData)
  },

  setCarePlan({ commit }, carePlanId) {
    commit('setServicePageData', {
      selectedCarePlan: carePlanId,
    })
  },

  clearCarePlan({ commit }) {
    commit('setServicePageData', {
      selectedCarePlan: '',
    })
  },
}
